import { gql } from "@apollo/client"

export default gql`
    query getPrompt($mediaUUID: String!) {
        getPrompt(mediaUUID: $mediaUUID) {
            name
            originalText
            languages {
                name
                code
            }
            fileName
            audioFormat {
                type
            }
            downloadableAudio {
                binaryData
            }
            playableAudio {
                binaryData
                size
                fileName
                fileExtension
            }
        }
    }
`
